import { render, staticRenderFns } from "./consumptionRule.vue?vue&type=template&id=09671316&scoped=true"
import script from "./consumptionRule.vue?vue&type=script&lang=js"
export * from "./consumptionRule.vue?vue&type=script&lang=js"
import style0 from "./consumptionRule.vue?vue&type=style&index=0&id=09671316&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09671316",
  null
  
)

export default component.exports